module.exports = __webpack_public_path__ + "static/media/lu_logo2.7e474025.png";